import React from 'react';
import PropTypes from 'prop-types';

import { censorTypes, useCensor } from '../../utils/hooks/useCensor/useCensor';
import Button from '../../atoms/Button';
import ToggleSwitch from '../../atoms/ToggleSwitch';
import { AlertIcon } from '../../atoms/Icons';
import TransportStatus from './TransportStatus';

function TransportMethodOption({
  id,
  name,
  icon: Icon,
  description,
  isSelected,
  onToggle,
  onTest,
  details,
  isPendingTest,
  disabled,
  showDetails,
}) {
  const { censor } = useCensor();
  const testButtonDisabled = !isSelected || disabled || isPendingTest || !!details?.testDisabled;

  return (
    <div className="TransportMethodSelector-option">
      <div className="TransportMethodSelector-optionHeader">
        <Icon className="TransportMethodSelector-icon" />
        <div className="TransportMethodSelector-optionText">
          <div className="TransportMethodSelector-optionName">{name}</div>
          {description && <div className="TransportMethodSelector-optionDescription">{description}</div>}
        </div>
      </div>
      <div className="TransportMethodSelector-optionRow">
        {showDetails && details && (
          <div className="TransportMethodSelector-optionValue">
            {censor(details.targetAddress, censorTypes.pii)}
          </div>
        )}
        {showDetails && (
          <div
            className={`TransportMethodSelector-testButtonWrapper ${
              isPendingTest ? 'TransportMethodSelector-testButtonWrapper--pending' : ''
            }`}
          >
            <Button
              content="Test"
              onClick={() => onTest(id)}
              disabled={testButtonDisabled}
              className={`TransportMethodSelector-testButton  TransportMethodSelector-testButton--pending ${
                isSelected && !details?.status && !testButtonDisabled ? 'TransportMethodSelector-testButton--pulse' : ''
              }
             
            `}
            />
          </div>
        )}
        <ToggleSwitch
          isActive={isSelected}
          onToggle={() => onToggle(id)}
          disabled={disabled}
          aria-label={`Enable ${name} notifications`}
        />
        <div className="TransportMethodSelector-information">
          {showDetails && details && (
            <div className="TransportMethodSelector-statusWarning">
              {details.configurationWarning && (
                <div className="TransportMethodSelector-optionStatus TransportMethodSelector-optionStatus--error">
                  <AlertIcon className="TransportMethodSelector-statusIcon" />
                  Configuration warning: {details.configurationWarning}
                </div>
              )}
              {!details.configurationWarning && <TransportStatus transportId={id} details={details} />}
            </div>
          )}
          {isSelected &&
            !['success', 'error', 'pending', 'unsubscribed'].includes(details?.status) &&
            !details?.configurationWarning && (
              <div className="TransportMethodSelector-finalizeSetup">
                <AlertIcon className="TransportMethodSelector-statusIcon TransportMethodSelector-statusIcon--finalizeSetup" />
                You must test this Notification Method to finalize setup.
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

TransportMethodOption.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  description: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onTest: PropTypes.func.isRequired,
  details: PropTypes.object,
  isPendingTest: PropTypes.bool,
  disabled: PropTypes.bool,
  showDetails: PropTypes.bool,
};

export default TransportMethodOption;
